import { ChangeEvent } from 'react';
import moment from 'moment';

interface DatePickerMonthListProps {
    month: moment.Moment;
    onMonthSelect: (date: moment.Moment, month: string) => void;
    onYearSelect: (date: moment.Moment, year: string) => void;
    yearMin?: number;
    numberOfMonths?: number;
}

const DatePickerMonthList = ({
    month: date,
    onMonthSelect,
    onYearSelect,
    yearMin,
    numberOfMonths = 1,
}: DatePickerMonthListProps) => {
    const currentYear = moment().year();
    const earliestYear = yearMin || currentYear - 1;
    const latestYear = currentYear + 3;

    const fiveYears = [];
    if (earliestYear) {
        for (let i = earliestYear; i <= latestYear; i++) {
            fiveYears.push(
                <option value={i} key={`year-${i}`}>
                    {i}
                </option>
            );
        }
    }

    const allMonths = moment.months().map((label, value) => (
        <option key={value} value={value}>
            {label}
        </option>
    ));

    const oneMonthStyles =
        parseInt(String(numberOfMonths)) === 1
            ? { justifyContent: 'center', marginRight: 0 }
            : {};

    return (
        <div className='CalendarMonth_SelectsContainer' style={oneMonthStyles}>
            <div className='CalendarMonth_MonthSelectContainer'>
                <select
                    value={date.month()}
                    onChange={(e: ChangeEvent<HTMLSelectElement>) =>
                        onMonthSelect(date, e.target.value)
                    }
                >
                    {allMonths}
                </select>
            </div>
            <div className='CalendarMonth_YearSelectContainer'>
                <select
                    value={date.year()}
                    onChange={(e: ChangeEvent<HTMLSelectElement>) =>
                        onYearSelect(date, e.target.value)
                    }
                >
                    {fiveYears}
                </select>
            </div>
        </div>
    );
};

export default DatePickerMonthList;
